// eslint-disable-next-line no-useless-escape
export const TIME_REGEX = /(\[|\()?((\d{1,4})(?![\r\n]):?(\d{1,2})?)(am|pm|a|p|AM|PM|A|P)?\s?(-|\/|\.|\*|to)?\s?((\d{1,4})+(:\d{1,2})?)?(am|pm|a|p|AM|PM|A|P)?(\)|\])?/g;
